import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';
import baseUrlGrader from '../base-url-grader';

const API_URL = baseUrl()+"/api/all/new/";
const API_GRADER_FETCH_MODUL = baseUrlGrader()+"/fetch-mata-uji"

const getSertifikasi = 'sertifikasi';
const getDetailSertifikasi = 'sertifikasi/';
const postSertifikasiUrl = 'sertifikasi';
const putSertifikasi = 'sertifikasi/';
const deleteSertifikasi = 'sertifikasi/';
const deleteDokumenPersyaratan = 'sertifikasi/delete-sertifikasi-dokumen/';
const deleteDokumenSertifikat = 'sertifikasi/delete-dokumen-sertifikat/';
const deleteMataUji = 'sertifikasi/delete-sertifikasi-mata-uji/';
const getSertifikasiRplPerKategori = 'sertifikasi-rpl/kategori-rpl/';
const getKategoriRpsl = 'sertifikasi-rpl/kategori-sertifikasi-rpl/';
const postSertifikasiRplUrl = 'sertifikasi-rpl';
const putSertifikasiRplUrl = 'sertifikasi-rpl/';
const getDetailSertifikasiRpl = '';

const exportSertifikasi = 'sertifikasi-export';

class SertifikasiServiceNew {

    getMataUji() {
        return axios.get(API_GRADER_FETCH_MODUL);
    }

    getKategoriSertifikasiRpl() {
        return axios.get(
            API_URL + getKategoriRpl + id_kategori_rpl ,{
            headers: authHeader()
        });
    }

    getSertifikasiRplPerKategori(id_kategori_rpl) {
        return axios.get(
            API_URL + getSertifikasiRplPerKategori + id_kategori_rpl ,{
            headers: authHeader()
        });
    }

    getSertifikasi(currentPage,pageSize,filter,idLevel) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            id_level : idLevel
        };
        
        return axios.get(
        API_URL + getSertifikasi ,{
            params : data,
            headers: authHeader()
        });
    }
    
    getDetailSertifikasi(idSertifikasi) {
        return axios.get(
        API_URL + getDetailSertifikasi + idSertifikasi,
        {
            headers: authHeader()
        });
    }

    postSertifikasi(formData) {                    
        return axios.post(API_URL + postSertifikasiUrl, formData,
        {
            headers: authHeader()
        });
    }

    postSertifikasiRpl(formData) {
        return axios.post(API_URL + postSertifikasiRplUrl, formData,
            {
                headers: authHeader()
            });
    }

    putSertifikasiRpl(formData, idSertifikasi) {
        return axios.put(API_URL + putSertifikasiRplUrl + idSertifikasi, formData,
            {
                headers: authHeader()
            });
    }

    putSertifikasi(formData, idSertifikasi) {       
        return axios.put(
            API_URL + putSertifikasi + idSertifikasi ,
            formData,
            {
                headers: authHeader()
            }
        );
    }

   

    deleteSertifikasi(formData) {

        return axios
            .delete(
                API_URL + deleteSertifikasi + formData.id_sertifikasi,
                { headers: authHeader() }
            );
    }

    deleteDokumenPersyaratan(id) {
        return axios.delete(API_URL + deleteDokumenPersyaratan + id, {
            headers: authHeader()
        });
    }

    deleteDokumenSertifikat(id) {
        return axios.delete(API_URL + deleteDokumenSertifikat + id, {
            headers: authHeader()
        });
    }

    deleteMataUji(id) {
        return axios.delete(API_URL + deleteMataUji + id, {
            headers: authHeader()
        });
    }
    
    exportDataSertifikasi(idLevel) {
        return axios.get(API_URL + exportSertifikasi + '?idLevel=' + idLevel, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

}

export default new SertifikasiServiceNew();
